import type BaseEnumType from "@/app/services/baseEnumType";
import type Key from "@/app/types/common/key";
import type { Maybe } from "@/components/utils/typeHelpers";
import { keys } from "@/plugins/i18n";

export class EnumIntegrationStatus implements BaseEnumType {
  private static allValues: EnumIntegrationStatus[] = []; // make sure this is top-most

  public static inactive = new EnumIntegrationStatus(
    0,
    "Inactive",
    "primary",
    keys.integrations_activate
  );
  public static unauthenticated = new EnumIntegrationStatus(
    1,
    "Unauthenticated",
    "primary-warn",
    keys.integrations_unauthenticated
  );
  public static active = new EnumIntegrationStatus(
    2,
    "Active",
    "primary-success",
    keys.integrations_activated
  );

  public key: number;
  public value: string;
  public buttonType: string;
  public buttonTextKey: Key;

  private constructor(
    key: number,
    value: string,
    buttonType: string,
    buttonTextKey: Key
  ) {
    this.key = key;
    this.value = value;
    this.buttonType = buttonType;
    this.buttonTextKey = buttonTextKey;
    EnumIntegrationStatus.allValues.push(this);
  }

  public equals(other: Maybe<EnumIntegrationStatus>): boolean {
    return this.key === other?.key;
  }

  public isInactive() {
    return this.equals(EnumIntegrationStatus.inactive);
  }

  public isUnauthenticated() {
    return this.equals(EnumIntegrationStatus.unauthenticated);
  }

  public isActive() {
    return this.equals(EnumIntegrationStatus.active);
  }

  public static getValues(): EnumIntegrationStatus[] {
    return EnumIntegrationStatus.allValues;
  }

  public static getByKey(key: number): EnumIntegrationStatus {
    const found = EnumIntegrationStatus.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumIntegrationStatus - Key not found: ${key}`);
    }

    return found;
  }
}
export interface OrderImporterFunction {
  (maximumCount: number | null): Promise<OrderImporterResults>;
}

export interface OrderImporterResults {
  importedCount: number;
  processedButNotImported: number;
  remainingToProcessCount: number;
}
